import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseFreeformPicker from '../BaseFreeformPicker/BaseFreeformPicker'
import Caption from '../PageAssembler/InnerComponents/ImagePicker/Caption/Caption'

const FreeformTextBox = ({
  picker,
  onPositionCommit,
  onRotateCommit,
  onDelete,
  onActivate,
  stickerBoundsRef,
  pageOffset,
  isPrintView = false,
  zindex,
}) => {
  const [t] = useTranslation()

  const { pickerData = {} } = picker
  const { textType = 'caption', caption = '', title = '' } = pickerData

  const isHeading = textType === 'title'

  // Default width for character limit calculation
  const DEFAULT_WIDTH = 350

  const calculateCharacterLimit = (width, isHeadingType) => {
    const maxLimit = isHeadingType ? 50 : 100

    if (width >= DEFAULT_WIDTH) {
      return maxLimit
    }

    const scaledLimit = Math.floor((width / DEFAULT_WIDTH) * maxLimit)
    return Math.max(10, scaledLimit)
  }

  return (
    <BaseFreeformPicker
      picker={picker}
      onPositionCommit={onPositionCommit}
      onRotateCommit={onRotateCommit}
      onDelete={onDelete}
      onActivate={onActivate}
      stickerBoundsRef={stickerBoundsRef}
      pageOffset={pageOffset}
      isPrintView={isPrintView}
      zindex={zindex}
      resizeMode="horizontalOnly"
      maxSize={400}
      minSize={100}
      defaultSize={DEFAULT_WIDTH}
      contentDescription={t('FreeformTextBox.defaultDescription', 'Draggable text box')}
      deleteButtonTitle={t('FreeformTextBox.deleteButton.title', 'Remove draggable')}
      testIdPrefix={`freeform-text-box-${picker.id}`}
      renderContent={(contentProps) => {
        const maxLength = calculateCharacterLimit(contentProps.dimensions.width, isHeading)

        // In layout mode, wrap Caption in flex container for centering
        if (!contentProps.isPrintView) {
          return (
            <div
              style={{
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  width: '100%',
                  flexShrink: 0,
                }}
              >
                <Caption
                  caption={caption}
                  title={title}
                  pageNumber={contentProps.pageNumber}
                  positionIndex={0}
                  isHeading={isHeading}
                  isPrintView={contentProps.isPrintView}
                  customLayoutElementId={contentProps.customLayoutElementId}
                  onUpdateCustomLayoutElementData={contentProps.onUpdateCustomLayoutElementData}
                  maxLength={maxLength}
                />
              </div>
            </div>
          )
        }

        // In print view, render Caption directly with special props
        return (
          <Caption
            caption={caption}
            title={title}
            pageNumber={contentProps.pageNumber}
            positionIndex={0}
            isHeading={isHeading}
            isPrintView={contentProps.isPrintView}
            customLayoutElementId={contentProps.customLayoutElementId}
            onUpdateCustomLayoutElementData={contentProps.onUpdateCustomLayoutElementData}
            maxLength={maxLength}
            fillHeight
            alwaysShowBackground
          />
        )
      }}
    />
  )
}

export default FreeformTextBox
